import React, { FC } from 'react';

import { LOCALE } from '@/utils/base';

import Link from './Link';

interface Props {
  title: string;
}

const LinkPersonalDataProcessing: FC<Props> = ({ title }) => (
  <Link
    to={LOCALE === 'ru' ? '/personal-data-processing-consent' : '/docs/personal-data-processing-consent_en.pdf'}
    target="_blank"
  >
    {title}
  </Link>
);
export default LinkPersonalDataProcessing;
